import ReactPDF, { View, Page, Text, Font, Image, Link } from "@react-pdf/renderer";
import { AnalyzeData } from '../model/AnalyzeData';
import { riskLevel } from "../components/AnalyseCalc";
import { styles } from "./pdfstyles";
import { DangerRow } from "./DangerRow";
import { TableRow } from "./TableRow";

export default function AnalyzeDataPDF(pdf: AnalyzeData) {

    Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
    })

    return (
        <ReactPDF.Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.title}>
                    <Image src="https://e-rodo.eu/images/ready/analiza_ryzyka.jpg" style={{height: "171px"}} />
                </View>
                <View style={styles.title}>
                    <Text></Text>
                </View>
                <View style={styles.centerPage}>
                    <TableRow name="Rodzaj (grupa) zasobów" value={pdf.groupOfResources} />
                    <TableRow name="Zasoby" value={pdf.resource} />
                    <TableRow name="Zabezpieczenia techniczne" value={pdf.technicalProtection} />
                    <TableRow name="Zabezpieczenia organizacyjne" value={pdf.organisationalProtection} />
                    <TableRow name="Luki (możliwe uchybienia, podatności)" value={pdf.vulnerability} />
                    <DangerRow name="Zagrożenia" values={pdf.risks.map(x => x.name)} />
                    <DangerRow name="Źródło" values={pdf.risks.map(x => x.source)} />
                    <DangerRow name="Prawdopodobieństwo" values={pdf.risks.map(x => x.probability)} />
                    <DangerRow name="Waga" values={pdf.risks.map(x => x.effect)} />
                    <DangerRow name="Ryzyko" values={pdf.risks.map(x => riskLevel(x).text)} />
                    <DangerRow name="Działania do podjęcia" values={pdf.risks.map(x => x.wayOfDeal)} />
                    <DangerRow name="Zalecenia" values={pdf.risks.map(x => x.recommendations)} />
                </View>
                <View style={styles.mt2}>
                    <Text style={styles.textTitle}>Zastrzeżenie dot. ograniczeń</Text>
                    <Text style={styles.text}>Wyniki podane przez kalkulator są orientacyjne i pomocnicze, nie mogą być jedyną podstawą do podejmowania działań ani do pełnej diagnozy stanu faktycznego. Nie ponosimy jakiejkolwiek odpowiedzialności za skutki uboczne korzystania z kalkulatora. Dodatkowe szczegóły w zakresie przepisów prawa: art. 24 i art. 32 RODO.</Text>
                </View>
                <View>
                    <Text style={styles.textTitle}>Kontakt z nami</Text>
                    <Text style={styles.text}>Potrzebujesz pomocy? Skontaktuj się z nami i umów się na spotkanie.</Text>
                </View>
                <View style={styles.center}>
                    <Link src="https://e-rodo.eu/kontakt.php#contact-section">
                        <Image src="https://e-rodo.eu/images/ready/PDF.jpg" style={{height: "171px"}} />
                    </Link>
                </View>
            </Page>
        </ReactPDF.Document>
    )
}